import { Platform } from "react-native";

/**
 * 3D icon URLs from thiings.co
 * https://www.thiings.co/things
 */
const CDN = "https://lftz25oez4aqbxpq.public.blob.vercel-storage.com";

export const THIINGS = {
  egg: `${CDN}/image-7uzNN0YrOHMfME1JRXstP9EgkWw5lf.png`,
  snowflake: `${CDN}/image-LqXYHapkTuVSr3KjAJoS5u0Pl6Yq5D.png`,
  hourglass: `${CDN}/image-jZvuQMZCi8XuT0afzKwdnQXwS7maTf.png`,
  beaker: `${CDN}/image-WsDBdp5sYLXwpFR8P8SeEXc0EdgHNE.png`,
  hospital: `${CDN}/image-rW3KN717rl4aTnOGRIuS82n0gSwwLQ.png`,
  syringe: `${CDN}/image-pK4NZDRK2QPjJrVx7YL17gcmgt2JNO.png`,
  pill: `${CDN}/image-RfZWMYPolUNkF8E5eI5LriAMjXdsXh.png`,
  dna: `${CDN}/image-RSCqQgrjVGAcuRmzFKB3GMNZmCsun8.png`,
  stethoscope: `${CDN}/image-YM427q0rp7oBdrNFxZLbdSyYBZNTjA.png`,
  book: `${CDN}/image-QhvfavmoGfPmREwwvl4XtqTIORARDz.png`,
  calendar: `${CDN}/image-ij7GEZhfmzLNlLgDJVhkST8FIm5rJV.png`,
  magnifyingGlass: `${CDN}/image-QPl7zSOxUKmFrWf7nOJIZNsfnurbAG.png`,
  lightningBolt: `${CDN}/image-kEc3FuOo6TejgI0tivfA8qPm4YIWfV.png`,
  heart: `${CDN}/image-RQtOXVb8LaWRBM1vFtlMCggGMulrKV.png`,
  money: `${CDN}/image-IeKGYKeLd25OWlrmd5WrSsfbD7OIPA.png`,
  gear: `${CDN}/image-5WOZbM8gOwMf0RATXQa7UL57OKFSMg.png`,
  yoga: `${CDN}/image-m2SOQuJWIeR3yhaHHkIn6ueDQ5KAEZ.png`,
  team: `${CDN}/image-6v7txf6fYZ44PMqYqpJXauAY0PWiRH.png`,
  notebook: `${CDN}/image-V5g1BA4Fg3Mgks7vN6n3eaXb8KBz0g.png`,
  box: `${CDN}/image-SSBtrTO0QRBRm4ldsdYVYECocsQVOk.png`,
  chart: `${CDN}/image-gJgeXqFZbbutMpZyph69ryLkBlvJ77.png`,
  checkbox: `${CDN}/image-qttnPzdnbj8WEwht2JpTxc7Sid8JRr.png`,
  sparkle: `${CDN}/image-SJcxLxIC8lH8u7d9CvcOGIULgEz7wX.png`,
  shield: `${CDN}/image-CZxT18DNf12Vjv8rrZv8V0tddRi9Xu.png`,
  clipboard: `${CDN}/image-yFtjfKzQBiN4N3in0hmfzJN0a4u71g.png`,
  lightbulb: `${CDN}/image-JaLO4GvMZea2az0FyzzLXFoWFyjJOB.png`,
  handshake: `${CDN}/image-g0jWpKzDefUBkVrz5WRvIkWjsUYOer.png`,
  checkmark: `${CDN}/image-HiChF8iNxEQpjV9vKH44UoEduGznyr.png`,
  document: `${CDN}/image-BjimxRD0gb4rZBjr9jbO9LYXmOZJao.png`,
  couple: `${CDN}/image-qTUvWdU0Wr0fenyLJqPeBX04tjW9Si.png`,
  bicep: `${CDN}/image-nWNb6Avbb9G1AYnIXiRqFm5CcbZm46.png`,
  thoughtBubble: `${CDN}/image-Rp64bwwUJcppvFX5QmwaL7wQYXFTDN.png`,
  chick: `${CDN}/image-9Be3vPrwLlkNA90W04bLIBzD67rt4O.png`,
  piggyBank: `${CDN}/image-yXrodRQ1tufqDh2wXeFl82sDXZBv3c.png`,
  taxes: `${CDN}/image-udfcsUoZR7zXz08IhYfvQy3HnjPoYy.png`,
  babyBottle: `${CDN}/image-OGmaUYElcQxL0MXidTpKtrdWi3UztG.png`,
} as const;

export type ThiingsIconName = keyof typeof THIINGS;

// ── Sepia filter style for web (warm tint on 3D icons) ──

export const TINTED_ICON_FILTER =
  Platform.OS === "web"
    ? { filter: "sepia(0.4) saturate(0.8) brightness(0.95)" }
    : {};
